import { mergeObservacionesGuiaForPayload } from './residuosObservacionesAuto';

/**
 * Construye `guide_details` para warehouse desde ítems del formulario (misma lógica que RegisterWorkflow).
 * @param {Array} items - `formValues.items`
 * @returns {Array<Object>}
 */
export function buildResiduosGuideDetailsFromFormItems(items) {
	return (
		items
			?.filter(item => item._module_vars?.residue_id)
			.map(item => ({
				residue_id: item._module_vars.residue_id,
				unit_measurement_id: item._module_vars.unit_measurement_id,
				amount: item.QtyItem,
				residue_kilograms: item._module_vars.residue_kilograms,
				residue_collected_kilograms:
					item._module_vars.residue_collected_kilograms || 0,
				residue_collected_ids: item._module_vars.residue_collected_ids || [],
				ph_ensilage: item._module_vars.ph_ensilage || null,
				hydrogen_sulfide: item._module_vars.hydrogen_sulfide || null,
				number_of_bins: item._module_vars.number_of_bins || null,
				especie: item._module_vars.especie || null,
				fish_count: item._module_vars.fish_count || null,
				cubic_meters: item._module_vars.cubic_meters || null,
				has_flow_meter: item._module_vars.has_flow_meter || null,
				period: item._module_vars.period || null,
				cultivation_center_origin:
					item._module_vars.cultivation_center_origin || null,
				siep_code_cultivation_center:
					item._module_vars.siep_code_cultivation_center || null,
				cage_origin: item._module_vars.cage_origin || null,
				bin_seal_folios: item._module_vars.bin_seal_folios || null,
				market_restrictions: item._module_vars.market_restrictions || null,
				es_valorizable: item._module_vars.es_valorizable || false,
				valor: item._module_vars.valor || null,
				moneda: item._module_vars.moneda || null,
				valor_clp: item._module_vars.valor_clp || null,
			})) || []
	);
}

/**
 * Payload compartido para `createWarehouseGuide` (listado unificado) en flujos residuos.
 *
 * @param {Object} params
 * @param {string} params.dteId
 * @param {string|number} params.folio
 * @param {string} params.documentId
 * @param {Object} params.formValues
 * @param {string|null} params.resGuideId - `residue_guide_id` en warehouse
 * @param {Array<Object>} params.guideDetails - resultado de `buildResiduosGuideDetailsFromFormItems`
 * @returns {Object}
 */
export function buildResiduosWarehouseGuidePayload({
	dteId,
	folio,
	documentId,
	formValues,
	resGuideId,
	guideDetails,
}) {
	return {
		folio: parseInt(folio, 10),
		dte_id: dteId,
		document_id: documentId,
		establishment_id: formValues.establishment_id,
		guide_category: 'residuos',
		operation_type: formValues.residuos_operation_type || 'peligrosos',
		items_payload: {
			items_detail: (formValues.items || []).filter(
				i => !i._module_vars?._is_auto_item,
			),
		},
		mnt_neto: Math.round(Number(formValues.totals_mnt_neto) || 0),
		mnt_iva: Math.round(Number(formValues.totals_iva) || 0),
		mnt_total: Math.round(Number(formValues.totals_mnt_total) || 0),
		guide_date: formValues.guide_date
			? new Date(formValues.guide_date).toISOString()
			: new Date().toISOString(),
		observations: mergeObservacionesGuiaForPayload(formValues) || null,
		status_guide_id: 'active',
		residue_type_id: formValues.residue_type_id || null,
		destiny_type_id: formValues.destiny_type_id || null,
		warehouse_id: formValues.warehouse_id || null,
		final_destination_id: formValues.final_destination_id || null,
		guide_details: guideDetails,
		residue_guide_id: resGuideId || null,
	};
}
